(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomProjectTypeAttributeDetailController', CustomProjectTypeAttributeDetailController);

    CustomProjectTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomProjectTypeAttribute'];

    function CustomProjectTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomProjectTypeAttribute) {
        var vm = this;

        vm.customProjectTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customProjectTypeAttributeUpdate', function(event, result) {
            vm.customProjectTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
